import React from 'react'
import {useSelector} from 'react-redux'
import {isEmpty, isUndefined} from 'lodash'
import {SettingsOutlined, Close} from '@material-ui/icons';
import {Tooltip, IconButton, Menu, makeStyles, Divider, Grid, TextField, Select, MenuItem, InputLabel,FormControl,Button} from '@material-ui/core'
import data from '../../Widgets/data'
import TextSettings from './textSettings';
import TitelSettings from './titelSettings';
import TextSizeSettings from './textSizeSetting';
import BackGroudColorSettings from './BackGroudColorSetting';
import FontColorSettings from './FontColorSetting';
import ImageHeightSettings from './ImageHeightSetting';
import ChartTypeSettings from './ChartTypeSettings';
import ChartTitleSettings from './ChartTitleSettings';
import HAxisSettings from './HAxisSettings';
import VAxisSettings from './VAxisSettings';
import IntervalSettings from './intervalSettings';
import MainValueSettings from './mainValueSettings';
import UserCountSettings from './userCountSettings';
import IntervalJSettings from './intervalJSettings';
import TypeOptionGrowthSettings from './typeOptionGrowthSettings';
import CountDownSettings from './countDownSettings';
import DaysSettings from './daysSettings'
import LinkSrcSettings from './linkSrcSettings'
import ArtikelTags from './artikelTags'
import UserSettings from './usersSettings'
import StartDate from './startDate'
import OrderVardeSetting from './OrderVardeSetting'
import AbonnamangeSetting from './AbonnamangeSetting'
import moment from 'moment-timezone';
import IntlMessages from 'util/IntlMessages';
const useStyles = makeStyles({
  menu: {
    '& .MuiMenu-paper': {
      width: '350px',
      paddingLeft: '10px',
      paddingRight: '10px',
    }
  },
  w30px: {
    width: 30
  },
  cardSideOptionsButton: {
    textTransform: 'none'
  },
});

export default function WidgetSettings(props) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [settings, setSettings] = React.useState([])
  const Userlista = useSelector(state => state.accountsData.Userlista)
  const authUser = useSelector(state => state.auth.authUser)

  const [text, setText] = React.useState(props.text)
  const [textSize, setTextSize] = React.useState(props.textSize)
  const [BackGroudColor, setBackGroudColor] = React.useState(props.BackGroudColor)
  const [ImageHeight, setImageHeight] = React.useState(props.ImageHeight)
  const [chartType, setchartType] = React.useState(props.chartType)
  const [title, setTitle] = React.useState(props.title)
  const [hAxis, sethAxis] = React.useState(props.hAxis)
  const [vAxis, setvAxis] = React.useState(props.vAxis)
  const [FontColor, setFontColor] = React.useState(props.FontColor)
  const [intervaltype, setIntervaltype] = React.useState(props.intervaltype)
  const [mainValue, setmainValue] = React.useState(props.mainValue)
  const [userCount, setuserCount] = React.useState(props.userCount)
  const [typeoptiongrowth, setTypeoptiongrowth] = React.useState(props.typeoptiongrowth)
  const [countStart, setCountStart] = React.useState(moment(props.countStart))
  const [countEnd, setCountEnd] = React.useState(moment(props.countEnd))
  const [daysForward, setdaysForward] = React.useState(props.daysForward)
  const [daysBackward, setdaysBackward] = React.useState(props.daysBackward)
  const [linkSrc, setLinkSrc] = React.useState(props.linkSrc)
  const [tagsJSON, setTagsJSON] = React.useState(props.tagsJSON)
  const [usersJSON, setUsersJSON] = React.useState(props.usersJSON)
  const [startDate, setStartDate] = React.useState(props.startDate)
  const [orderVardeSetting, setOrderVardeSetting] = React.useState(props.orderVardeSetting)
  const [abonnamangeSetting, setAbonnamangeSetting] = React.useState(props.abonnamangeSetting)


  const handleClick = (event) => {
    props.setOpen(true)
    setAnchorEl(event.currentTarget);
    setText(props.text)
    setTextSize(props.textSize)
  };

  const handleClose = () => {
    props.setOpen(false)
    setAnchorEl(null);
  };

  React.useEffect(() => {
    let item = data.find(d => d.type === props.type)
    console.log(props)
    console.log(item)
    if(!isUndefined(item)) setSettings(isUndefined(item.settings) ? [] : item.settings)
  }, [])

  const handleSave = () => {
    handleClose()
    props.updateDateBlock({
      ...props, 
      text,
      textSize,
      BackGroudColor,
      ImageHeight,
      chartType,
      title,
      hAxis,
      vAxis,
      FontColor,
      countStart,
      countEnd,
      intervaltype,
			mainValue,
			userCount,
      typeoptiongrowth,
      daysForward,
      daysBackward,
      linkSrc,
      tagsJSON,
      usersJSON,
      startDate,
      orderVardeSetting,
      abonnamangeSetting
    })
  }

  return (
    <>
      {
        !isEmpty(settings) &&
        <Tooltip title={<IntlMessages id="Account.settings"/>}>
          <IconButton onClick={handleClick} size="small" color="primary">
            <SettingsOutlined/>
          </IconButton>
        </Tooltip>
      } 
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.menu}
        variant={'menu'}
      >
        <div className="d-flex align-items-center justify-content-between w-100">
          <span className={classes.w30px}>
            
          </span>
          <span>
          <IntlMessages id="Account.settings"/>
          </span>
          <span><IconButton size="small" onClick={handleClose}><Close style={{fontSize: 18}}/></IconButton></span>
        </div>
        <Divider className={'mt-2 mb-3'}/> 
        <Grid container spacing={1}>
          { !isEmpty(settings.filter(s => s === 'text')) &&
            <TextSettings
              text={text}
              setText={setText}
            />}
          { !isEmpty(settings.filter(s => s === 'titel')) &&
            <TitelSettings
              text={text}
              setText={setText}
            />}
          { !isEmpty(settings.filter(s => s === 'countdown')) &&
            <CountDownSettings
              countStart={countStart}
              setCountStart={setCountStart}
              countEnd={countEnd}
              setCountEnd={setCountEnd}
            />}
             { !isEmpty(settings.filter(s => s === 'chartType')) &&
            <ChartTypeSettings
              chartType={chartType}
              setchartType={setchartType}
            />}
          { !isEmpty(settings.filter(s => s === 'title')) &&
            <ChartTitleSettings
            title={title}
              setTitle={setTitle}
            />}
          { !isEmpty(settings.filter(s => s === 'hAxis')) &&
            <HAxisSettings
            hAxis={hAxis}
            sethAxis={sethAxis}
            />}
          { !isEmpty(settings.filter(s => s === 'vAxis')) &&
            <VAxisSettings
            vAxis={vAxis}
              setvAxis={setvAxis}
            />}
          { !isEmpty(settings.filter(s => s === 'textSize')) &&
            <TextSizeSettings
              textSize={textSize}
              setTextSize={setTextSize}
            />}
          { !isEmpty(settings.filter(s => s === 'BackGroudColor')) &&
            <BackGroudColorSettings
            BackGroudColor={BackGroudColor}
              setBackGroudColor={setBackGroudColor}
            />}
          { !isEmpty(settings.filter(s => s === 'ImageHeight')) &&
            <ImageHeightSettings
            ImageHeight={ImageHeight}
              setImageHeight={setImageHeight}
            />}
         
          { !isEmpty(settings.filter(s => s === 'FontColor')) &&
            <FontColorSettings
            FontColor={FontColor}
              setFontColor={setFontColor}
            />}
          { !isEmpty(settings.filter(s => s === 'typeoptiongrowth')) &&
            <TypeOptionGrowthSettings
              typeoptiongrowth={typeoptiongrowth}
              setTypeoptiongrowth={setTypeoptiongrowth}
            />}
          { !isEmpty(settings.filter(s => s === 'interval')) &&
            <IntervalSettings
              intervaltype={intervaltype}
              setIntervaltype={setIntervaltype}
            />}
          { !isEmpty(settings.filter(s => s === 'intervalJ')) &&
            <IntervalJSettings
              intervaltype={intervaltype}
              setIntervaltype={setIntervaltype}
            />}
          { !isEmpty(settings.filter(s => s === 'mainValue')) &&
            <MainValueSettings
              mainValue={mainValue}
              setmainValue={setmainValue}
            />}
          { !isEmpty(settings.filter(s => s === 'userCount')) &&
            <UserCountSettings
              userCount={userCount}
              setuserCount={setuserCount}
            />}
          { !isEmpty(settings.filter(s => s === 'days')) &&
            <DaysSettings
              daysForward={daysForward}
              setdaysForward={setdaysForward}
              daysBackward={daysBackward}
              setdaysBackward={setdaysBackward}
            />}
          { !isEmpty(settings.filter(s => s === 'linkSrc')) &&
            <LinkSrcSettings
              linkSrc={linkSrc}
              setLinkSrc={setLinkSrc}
            />}
          { !isEmpty(settings.filter(s => s === 'tags')) &&
            <ArtikelTags
              tagsJSON={tagsJSON}
              setTagsJSON={setTagsJSON}
            />}
          { !isEmpty(settings.filter(s => s === 'users')) &&
            <UserSettings
              usersJSON={usersJSON}
              setUsersJSON={setUsersJSON}
            />}
          { !isEmpty(settings.filter(s => s === 'start-date')) &&
            <StartDate
              startDate={startDate}
              setStartDate={setStartDate}
            />}
            {
              !isEmpty(settings.filter(s => s === 'OrderVarde')) &&
              <OrderVardeSetting
              orderVardeSetting={orderVardeSetting}
              setOrderVardeSetting={setOrderVardeSetting}
              />
            }
            {
              !isEmpty(settings.filter(s => s === 'Abonnamange')) &&
              <AbonnamangeSetting
              abonnamangeSetting={abonnamangeSetting}
              setAbonnamangeSetting={setAbonnamangeSetting}
              />
            }
          <Grid item xs="12">  
            <Button
              fullWidth
              onClick={handleSave}
              color="primary"
              variant="outlined"
              size="small"
            >
              <IntlMessages id="Save"/>
            </Button>
          </Grid>
        </Grid>
      </Menu>
    </>
  );
}
